import './TileContentLocked.scss';
import classNames from 'classnames';
import { Icon, type IconProps } from '@components/icon';
import { Box } from '@components/layout';
import { TileItem, type TileItemProps } from '@components/tile/TileItem';

export interface TileContentLockedProps {
  /** When false, skips the content-locked overlay. Default: `true`. */
  showOverlay?: boolean;
  /** Additional class name for the lock tile item. */
  className?: string;
  /** Padding around the lock icon. Default: `small`. */
  padding?: Extract<TileItemProps['padding'], 'small' | 'medium' | 'large'>;
  /** Lock icon size. Default: `small`. */
  iconSize?: Extract<IconProps['size'], 'small' | 'medium'>;
}

/**
 * Lock icon and optional overlay for locked tile content.
 * @param showOverlay - When false, skips the content-locked overlay. Default: `true`.
 * @param className - Additional class name for the lock tile item.
 * @param padding - Padding around the lock icon. Default: `small`.
 * @param iconSize - Lock icon size. Default: `small`.
 */
export const TileContentLocked: React.FC<TileContentLockedProps> = ({
  showOverlay = true,
  className,
  padding = 'small',
  iconSize = 'small',
}) => {
  return (
    <>
      {showOverlay && (
        <Box
          overlayVariant="content-locked"
          overlayOpacity="opacity-100"
          className="vds-tile-locked-content__icon-wrapper"
        />
      )}
      <TileItem
        position="bottom-right"
        className={classNames('vds-tile-locked-content', className)}
        padding={padding}>
        <Icon name="lock" size={iconSize} className="vds-tile-locked-content__icon" />
      </TileItem>
    </>
  );
};
